import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const collapseShadeSelectorsSelector = createSelector(testTargetOffersSelector, offers => offers?.collapseShadeSelectors || Empty.Object);

export { collapseShadeSelectorsSelector };
